import { connection } from "@/lib/connection";

/** Respuesta del endpoint de asientos ocupados */
export type AsientosOcupadosResponse = {
    ocupados: string[];
    bloqueados: string[];
    confirmados: number;
    reservados: number;
};

/** Respuesta del endpoint de stock disponible */
export type StockDisponibleResponse = {
    funcionId: string;
    entradas: Array<{
        tipoEntradaId: string;
        nombre: string;
        color: string | null;
        precio: number;
        capacidad: number;
        vendidas: number;
        reservadas: number;
        disponible: number;
    }>;
    resumen: {
        capacidadTotal: number;
        vendidasTotal: number;
        reservadasTotal: number;
        disponibleTotal: number;
    };
};

const API_URL = '/api/funciones';

/**
 * Obtiene los asientos ocupados (confirmados + reservados) para una función
 */
export async function getAsientosOcupados(funcionId: string): Promise<{ ocupados: string[]; bloqueados: string[] }> {
    const data = await connection<AsientosOcupadosResponse>(
        `${API_URL}/${funcionId}/asientos-ocupados`,
        'GET'
    );
    return { ocupados: data.ocupados, bloqueados: data.bloqueados ?? [] };
}

/**
 * Obtiene el stock disponible para una función sin mapa
 */
export async function getStockDisponible(funcionId: string): Promise<StockDisponibleResponse> {
    const data = await connection<{ stock: StockDisponibleResponse }>(
        `${API_URL}/${funcionId}/stock`,
        'GET'
    );
    return data.stock;
}

/** Respuesta del endpoint de entradas */
export type EntradasResponse = {
    entradas: Array<{
        id: string;
        tipoEntradaId: string;
        funcionId: string;
        precio: number;
        capacidad: number;
        vendidas: number;
        tipo: {
            id: string;
            nombre: string;
            color: string;
        } | null;
    }>;
};

/**
 * Obtiene entradas de una función con metadata (precio, color, nombre)
 * Llamando al BFF
 */
export async function getEntradas(funcionId: string): Promise<EntradasResponse> {
    const data = await connection<EntradasResponse>(
        `${API_URL}/${funcionId}/entradas`,
        'GET'
    );
    return data;
}